module.exports = __webpack_public_path__ + "img/video-placeholder.9023a2ba.jpg";